import { useIntl } from "react-intl";

import { Image } from "@/components/Image/Image";
import { ReservationDocumentList } from "@/features/bookings/components/ReservationDocumentList";
import { BookedHotelCard } from "@/features/hotels/components/hotels-list/BookedHotelCard";
import type { FindUserReservationHotelReservation } from "@/types/codegen";

import { ReservationNextSteps } from "./ReservationNextSteps";
import { ReservationPaymentDetails } from "./ReservationPaymentDetails";

type Props = {
  reservation: FindUserReservationHotelReservation;
};

export const MyHotel = ({ reservation }: Props) => {
  const intl = useIntl();

  return (
    <>
      <BookedHotelCard reservation={reservation.externalReservation} />

      <section className="section-card mt-2 mb-4 flex w-full items-center justify-between gap-4">
        <span className="section-title mb-0">
          {intl.formatMessage({
            id: "reservations.bookingNumber",
            defaultMessage: "Booking number",
          })}
        </span>
        <span className="text-base font-semibold text-text-title">
          {reservation.externalReservation.reference.external}
        </span>
      </section>

      <ReservationDocumentList reservationId={reservation.reservationId} />

      <section>
        <h3 className="section-title mt-4">
          {intl.formatMessage({
            id: "reservations.roomDetails",
            defaultMessage: "Room details",
          })}
        </h3>
        <ul className="section-card flex w-full flex-col gap-4">
          {reservation.externalReservation.rooms.map((room) => (
            <li
              key={room.id}
              className="flex justify-between gap-4 rounded-2xl bg-[#F3F4F7] p-3 text-sm font-medium"
            >
              <div>
                {[room.name, room.board, room.info].filter(Boolean).join(" - ")}
              </div>

              {reservation.externalReservation.hotel.mainImageUrl ? (
                <div className="relative h-[48px] w-[60px] overflow-clip rounded-lg">
                  <Image
                    className="h-full w-full object-cover"
                    src={reservation.externalReservation.hotel.mainImageUrl}
                    alt={reservation.externalReservation.hotel.name}
                    width={60}
                    height={48}
                  />
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </section>

      <ReservationPaymentDetails reservation={reservation} />
      <ReservationNextSteps type="hotel" />
    </>
  );
};
